import React from 'react';
import { useNavigate } from 'react-router-dom';
import useNotifications from '../hooks/useNotifications';
import { formatDistanceToNow } from 'date-fns';

/**
 * NotificationList Component
 * 
 * Shows list of notifications
 * Clicking a notification navigates to the relevant page
 */

const NotificationList = ({ onClose }) => {
  const navigate = useNavigate();
  const { notifications, markAsRead, markAllAsRead, deleteAllRead } = useNotifications();

  const handleNotificationClick = async (notification) => {
    // Mark as read
    if (!notification.is_read) {
      await markAsRead(notification.id);
    }

    // Navigate to link
    if (notification.link) {
      navigate(notification.link);
      onClose();
    }
  };

  return (
    <div className="max-h-96 overflow-y-auto">
      {/* Header */}
      <div className="flex items-center justify-between p-4 border-b">
        <h3 className="font-semibold">Notifications</h3>
        <div className="flex gap-2">
          <button
            onClick={markAllAsRead}
            className="text-sm text-blue-600 hover:underline"
          >
            Mark all read
          </button>
          <button
            onClick={deleteAllRead}
            className="text-sm text-gray-600 hover:underline"
          >
            Clear read
          </button>
        </div>
      </div>

      {/* Notifications */}
      <div>
        {notifications.map((notif) => (
          <div
            key={notif.id}
            onClick={() => handleNotificationClick(notif)}
            className={`p-4 border-b cursor-pointer hover:bg-gray-50 ${
              !notif.is_read ? 'bg-blue-50' : ''
            }`}
          >
            <div className="flex items-start gap-3">
              {!notif.is_read && (
                <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0" />
              )}
              <div className="flex-1">
                <p className="font-semibold text-sm">{notif.title}</p>
                <p className="text-sm text-gray-600 mt-1">{notif.message}</p>
                <p className="text-xs text-gray-500 mt-1">
                  {formatDistanceToNow(new Date(notif.created_at), { addSuffix: true })}
                </p>
              </div>
            </div>
          </div>
        ))}

        {notifications.length === 0 && (
          <div className="p-8 text-center text-gray-500">
            No notifications
          </div>
        )}
      </div>
    </div>
  );
};

export default NotificationList;
